import { jsxs as a, jsx as m } from "react/jsx-runtime";
import { forwardRef as p } from "react";
import { callAll as d } from "../../utils/utils.js";
import { Input as f } from "../Input/Input.js";
import '../../../assets/SelectInput.css';const u = "_select_4xmls_3", h = {
  select: u
}, j = p(
  ({
    options: e,
    children: l,
    onChange: n,
    onValueChange: r,
    "aria-invalid": o,
    ...s
  }, c) => /* @__PURE__ */ a(
    f,
    {
      ...s,
      as: "select",
      inputClassName: h.select,
      iconRight: "chevron-down",
      "aria-invalid": o,
      onChange: d(
        r && ((t) => r(t.currentTarget.value)),
        n
      ),
      ref: c,
      children: [
        e ? e.map(({ value: t, label: i }) => /* @__PURE__ */ m("option", { value: t, children: i }, t)) : null,
        l
      ]
    }
  )
);
export {
  j as SelectInput
};
